<template>
  <main>
    <Trail />
    <Container class="container--main">
      <Row>
        <ColumnUi md="12">
          <Title tag="h2">{{ "Glosario" }}</Title>
          <p>
            Descubre nuestra recopilación de definiciones o explicaciones de
            palabras técnicas sobre ciencia y todo lo que hacemos en el
            <b>IGP</b> de manera ordenada en de forma alfabética.
          </p>
          <Row>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Acelerómetro',
                    'Instrumento que mide las aceleraciones producidas por un movimiento y que en sismología registra básicamente la oscilación del suelo al paso de las ondas sísmicas por el punto de observación. El acelerómetro, junto al registrador constituye la estación acelerométrica.'
                  )
                "
              >
                Acelerómetro
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Amplitud',
                    'Máxima amplitud de la cresta de una onda sísmica identificada en el sismograma o registro del sismo. En general, la amplitud de la señal está directamente asociada a la cantidad de energía que libera el sismo, lo cual permite estimar su magnitud.'
                  )
                "
              >
                Amplitud
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Corteza',
                    'Considera a la capa rocosa exterior y más delgada de la superficie de la tierra, cuyo espesor promedio es de 7 kilómetros bajo los océanos y de 70 kilómetros en el área continental, como es el caso de la raíz de la cordillera de los andes.'
                  )
                "
              >
                Corteza
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Deriva Continental',
                    'Teoría expuesta por Alfred Wegener en 1912 para explicar el movimiento de los continentes en el tiempo a partir de una masa unificada de tierra. Wegener se basó en observaciones hechas en la geometría encajante de los continentes considerando su posición actual. Por ejemplo, el encaje entre el borde occidental de África y el borde oriental de sur América.'
                  )
                "
              >
                Deriva Continental
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Discontinuidad de Mohorovičić (el moho)',
                    'Define a la superficie de frontera que separa a la corteza del manto semilíquido en el interior de la tierra. Su existencia fue identificada a partir de la variación brusca de la velocidad sísmica por el sismólogo Andrija Mohorovičić, de origen croata.'
                  )
                "
              >
                Discontinuidad de Mohorovičić (el moho)
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Distancia Epicentral',
                    'Define a la distancia existente entre un observador y el epicentro de un sismo, medida sobre la superficie de la tierra. Al momento de georreferenciar el epicentro de un sismo se toma como referencia la plaza de principal de la ciudad y/o localidad y su ubicación con respecto al norte geográfico.'
                  )
                "
              >
                Distancia Epicentral
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Distancia Hipócentral',
                    'Define a la distancia calculada entre el hipocentro sísmico (ubicación del foco y/o fuente sísmica) y un punto sobre la superficie de la tierra que puede considerar la plaza principal de la ciudad y/o localidad o la estación sísmica de registro.'
                  )
                "
              >
                Distancia Hipócentral
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Epicentro',
                    'Se define como tal al punto exacto en la superficie que representa la proyección del hipocentro o foco sísmico.'
                  )
                "
              >
                Epicentro
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Escala Modificada de Mercalli',
                    'La escala de Mercalli modificada permite evaluar el grado de daño producido por un sismo en un determinado punto. Considera el nivel de percepción de las personas, efectos en estructuras y en la morfología. La escala consta de 12 valores expresados en números romanos que va desde los sismos que no son perceptibles hasta los que producen gran destrucción en ciudades y cambios importantes en la morfología del terreno.'
                  )
                "
              >
                Escala Modificada de Mercalli
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Escala de Magnitud',
                    'Representa a la escala que mide el total de la energía liberada en el foco sísmico y originalmente corresponde a la escala de Richter, propuesta por el autor en el año 1935. Es una escala logarítmica, lo que hace que los niveles asignados no tengan un comportamiento lineal y permiten medir sismos muy pequeños hasta los que alcanzarían valores en magnitud del orden de 6.5 Ml (llamada también escala de magnitud local, de ahí sus siglas “Ml”). En la actualidad la escala de magnitud más acertada y más utilizada es la escala de magnitud de momento (Mw) en razón que permite medir sin restricción sismos pequeños y grandes como el ocurrido en Japón en el año 2011.'
                  )
                "
              >
                Escala de Magnitud
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Estación Sismológica',
                    'Punto o lugar en donde se tiene operando o funcionando una estación sísmica para el registro de las ondas sísmicas. Un conjunto de estaciones sísmicas constituyen una red sismológica, pudiendo ser local cuando las dimensiones del área de monitoreo no es mayor a 200 km, regional hasta 5,000 km y mundial cuando se monitorea todo el globo terráqueo.'
                  )
                "
              >
                Estación Sismológica
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Falla Geológica',
                    'Considera a la superficie de contacto entre dos bloques de roca que se desplazan o han sido desplazados en el pasado en forma diferencial uno con respecto al otro y que en el momento de formación estaban unidos. Se pueden extender espacialmente por varios cientos de km y en forma temporal por varios millones de años. Desde el punto de vista geológico, una falla activa es aquella en la cual ha ocurrido desplazamiento en los últimos 2 millones de años; mientras que, desde el punto de vista sísmico se considera activas si ellas producen sismos sin importar su magnitud.'
                  )
                "
              >
                Falla Geológica
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Hipocentro o Foco',
                    'Define al punto en el interior de la tierra, en el cual se da inicio a la liberación de energía causada por la ruptura y generación de un sismo, este punto indica la ubicación de la fuente sísmica.'
                  )
                "
              >
                Hipocentro o Foco
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Hora Local y Universal (UTC)',
                    'Indica la hora o el tiempo que corresponde a una determinada región en el globo terrestre de acuerdo a su ubicación y longitud geográfica con respecto al meridiano estándar de referencia; es decir, el meridiano de Greenwich o parís. Según el estándar, cada 5° de longitud corresponden a una hora de tiempo. Para el caso de Perú la diferencia horaria es de menos 5 horas con respecto a la hora universal (UTC).'
                  )
                "
              >
                Hora Local y Universal (UTC)
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Hora o Tiempo Origen',
                    'Se refiere al momento exacto en que se produce la relajación súbita de los esfuerzos, es decir, el momento en que se inicia la ruptura en el foco o inicio del sismo. Esta puede ser referida a la hora local u hora universal (UTC).'
                  )
                "
              >
                Hora o Tiempo Origen
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Hora o Tiempo de Llegada de las Ondas',
                    'Indica el momento exacto en que una onda sísmica correspondiente a un evento sísmico llega a la estación sísmica para ser registrada por el sismómetro o acelerómetro.'
                  )
                "
              >
                Hora o Tiempo de Llegada de las Ondas
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Hora o Tiempo Universal',
                    'Indica la hora o el  tiempo que corresponde al meridiano universal de referencia y en este caso al meridiano de Greenwich o parís. Este tiempo de referencia, por convención internacional, se utiliza para la observación, registro y descripción de todo fenómeno geofísico y astrofísico.'
                  )
                "
              >
                Hora o Tiempo Universal
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Gal.',
                    'Representa la unidad de medida correspondiente a la aceleración de un centímetro por unidad de tiempo (segundos) al cuadrado (cm/seg2) de uso en sismología e ingeniería sísmica. En prospección geofísica se usa el mili gal (0.001 gal). El nombre de esta unidad de aceleración es en honor al astrónomo y físico Galileo.'
                  )
                "
              >
                Gal.
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Geofísica',
                    'Esta rama de la ciencia considera la aplicación de las teorías y procedimientos de las ciencias físicas al estudio de la tierra y sus fenómenos. En la actualidad, la geofísica y sus instrumentos de registro han permitido proponer diversidad de modelos para explicar la forma y la geodinámica de la tierra.'
                  )
                "
              >
                Geofísica
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Gap Sísmico',
                    'En sismología se refiere a la región geográfica o área donde históricamente han ocurrido sismos destructores, donde no han vuelto a ocurrir sismos de magnitudes similares por un periodo de tiempo bastante grande y en la actualidad muestran un nivel de actividad sísmica por debajo de lo normal de acuerdo a las observaciones hechas en las últimas decenas o centenas de años.'
                  )
                "
              >
                Gap Sísmico
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Intensidad',
                    'Refiere a la medida de los efectos producidos por un sismo en personas, animales, estructuras y terreno en un lugar particular. Los valores de intensidad se denotan con números romanos en la escala de intensidades de Mercalli modificada (Wood y Neumann, 1931) que clasifica los efectos sísmicos con doce niveles ascendentes en la severidad del sacudimiento. La intensidad no sólo depende de la fuerza del sismo (magnitud) sino que también de la distancia epicentral, la geología local, la naturaleza del terreno y el tipo de construcciones del lugar.'
                  )
                "
              >
                Intensidad
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Intervalo de Recurrencia Sísmica',
                    'Define al tiempo aproximado que se requiere para correlacionar la ocurrencia de terremotos en una determinada área sísmicamente activa.'
                  )
                "
              >
                Intervalo de Recurrencia Sísmica
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Isosistas o Mapa de Intensidades',
                    'La isosista define a la línea que une puntos de la superficie terrestre en donde la intensidad del terremoto es la misma. Generalmente, corresponde a una serie de curvas cerradas alrededor del epicentro, estando la de mayor valor cercana al epicentro para luego disminuir conforme se incrementa la distancia.'
                  )
                "
              >
                Isosistas o Mapa de Intensidades
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Licuefacción',
                    'Llámese al proceso por el cual un sólido, roca o depósito no consolidado (arena, lodo, arcilla), se comporta como un líquido debido al aumento en la presión de los poros, produciendo una reducción en la tensión, lo cual hace que algunas rocas se comporten como fluidos durante el desarrollo de los procesos que incrementan la presión de poros, tal como ocurre cuando se produce un evento sísmico.'
                  )
                "
              >
                Licuefacción
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Límite de Placa',
                    'Dícese al lugar en donde dos o más placas están en contacto, existen tres límites de placa: límites divergentes, límites convergentes y límites transformantes. En el caso del Perú, las Placas de Nazca y Sudamérica con del tipo convergentes.'
                  )
                "
              >
                Límite de Placa
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Manto',
                    'Corresponde a la capa de la tierra que se encuentra entre la corteza y el núcleo exterior de la tierra. Tiene aproximadamente 2900 kilómetros de espesor y es la capa con un volumen que abarca casi el 87% del total de la tierra. El manto se divide en manto superior y manto inferior, ambos diferenciados por presentar diferentes propiedades físicas y químicas.'
                  )
                "
              >
                Manto
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Microtremor',
                    'Nombre con el que se designa a los movimientos oscilatorios natural de la superficie terrestre producidos por una gran variedad de agentes naturales y artificiales como el viento, tránsito de vehículos y personas.'
                  )
                "
              >
                Microtremor
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'No Sísmico (Asísmico)',
                    'Básicamente define al proceso y/o área que no tiene relación alguna con la ocurrencia de movimientos sísmicos. En el caso de Placas tectónicas, la fricción entre ellas se realizaría sobre superficies no rígidas.'
                  )
                "
              >
                No Sísmico (Asísmico)
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Núcleo',
                    'Corresponde a la parte interna de la tierra y se divide en núcleo interno y núcleo externo. El núcleo interno es sólido y tiene un radio de aproximadamente 1300 kilómetros. El núcleo externo es fluido y es de aproximadamente 2300 kilómetros de espesor, compuesto principalmente por hierro y níquel.'
                  )
                "
              >
                Núcleo
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Onda',
                    'Una onda corresponde a una perturbación que se propaga desde el punto en que se originó hacia el medio que lo rodea hasta disiparse completamente. Las ondas materiales (todas menos las electromagnéticas) requieren un medio elástico para propagarse. El medio elástico se deforma y se recupera vibrando al paso de la onda. En sismología son llamadas ondas sísmicas y ellas cambian sus periodos de propagación conforme atraviesan diversos materiales.'
                  )
                "
              >
                Onda
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Ondas de Cuerpo',
                    'Se les llama así a las ondas que se propagan a través del interior de la tierra, sean en medios sólidos, líquidos o gaseosos. En sismología definen a las ondas P y S, conocidas como ondas primarias (P) de mayor velocidad que las ondas secundarias (S).'
                  )
                "
              >
                Ondas de Cuerpo
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Onda de Love',
                    'Son ondas llamadas superficiales y tienen un movimiento horizontal y perpendicular a la dirección de propagación, son transversales o de corte a la dirección de propagación. Reciben el nombre de ondas love en honor a Augustus Edward Hough Love, mejor conocido como A. E. H. Love, matemático y geofísico del reino unido.'
                  )
                "
              >
                Onda de Love
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Ondas P',
                    'Las ondas P o primarias son ondas longitudinales; es decir, que el medio por el cual se propagan es alternadamente comprimido y dilatado en la dirección de la propagación. Estas ondas viajan a una velocidad mayor que la velocidad de las ondas S y pueden hacerlo a través de cualquier tipo de material. La naturaleza del movimiento de sus partículas en el medio de propagación hace que estas se desplacen más rápido que otro tipo de ondas.'
                  )
                "
              >
                Ondas P
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Ondas S',
                    'Las ondas S o secundarias son ondas transversales o de corte; es decir, que el medio en el cual se propagan es desplazado perpendicularmente a la dirección de propagación, hacia un lado y hacia el otro. Las ondas S pueden viajar únicamente a través de sólidos, debido a que los líquidos no pueden soportar esfuerzos de corte. Su velocidad es alrededor del 60% la de una onda P para cualquier material sólido. La onda S tiene mayor amplitud que la P y es por ello, que durante la ocurrencia de un sismo, causa mayor daño.'
                  )
                "
              >
                Ondas S
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Ondas Rayleigh',
                    'Corresponde a una onda superficial que se mueve en forma retrógrada y elíptica. Son ondas con velocidad muy baja y se sienten como un movimiento ondulado o rodante. Son llamadas así en memoria de lord Rayleigh, un físico inglés que predijo su existencia.'
                  )
                "
              >
                Ondas Rayleigh
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Placa Tectónica',
                    'Corresponde a las divisiones de la litósfera de la tierra en trozos de diferente área. También son llamadas placas litosféricas, siendo ellas extensas y relativamente rígidas que se mueven en relación con otras placas de la litósfera. Las placas interactúan entre ellas en zonas denominadas límites de placa, siendo ellas convergentes, divergentes y transformantes. Es en estos límites en donde se producen los sismos.'
                  )
                "
              >
                Placa Tectónica
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Precursores o Premonitorios',
                    'De acuerdo a las condiciones geológicas y tectónicas de cada región, en ciertos casos es posible observar el registro de algunos sismos pequeños con anterioridad a la ocurrencia de un sismo principal. A estos sismos se les llama precursores. Sin embargo, al no presentarse con la suficiente regularidad, no pueden ser utilizados a modo de predecir sismos de mayor magnitud.'
                  )
                "
              >
                Precursores o Premonitorios
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Réplicas',
                    'Después de la ocurrencia de un sismo de gran magnitud, es posible la ocurrencia de muchos sismos de menor magnitud entorno al hipocentro del sismo principal. A estos sismos se les conoce como réplicas o aftershock. Algunas series de réplicas duran largo tiempo, incluso prolongarse por años. El área que encierra a los epicentros de las réplicas se llama área de réplicas.'
                  )
                "
              >
                Réplicas
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Sismo',
                    'Se define al proceso de generación y liberación de energía para posteriormente propagarse en forma de ondas por el interior de la tierra. Al llegar a la superficie, estas ondas son registradas por las estaciones sísmicas y percibidas por la población y por las estructuras.'
                  )
                "
              >
                Sismo
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Sismología',
                    'Es una rama de la geofísica que estudia los sismos y las propiedades elásticas de la tierra. entre sus campos de investigación se considera: a) el estudio de la propagación de las ondas sísmicas en el interior de la tierra a fin de conocer su estructura interna, b) el estudio de las causas que dan origen a eventos sísmicos y c) la prevención de daños. La sismología incluye, entre otros fenómenos, el estudio de tsunamis, el comportamiento dinámico del suelo y las vibraciones asociadas a erupciones volcánicas. El sismólogo, es la persona que aplica y estudia los principios y procedimientos sismológicos en su trabajo.'
                  )
                "
              >
                Sismología
              </div>
            </ColumnUi>
            <ColumnUi md="6" lg="4" class=" espacio">
              <div
                class="ter-glosario"
                @click="
                  openModalGlosario(
                    'Tsunamis',
                    'Los sismos de gran magnitud con epicentro en el mar, foco en la superficie de fricción de Placas a profundidades no mayores a 60 km y magnitud del orden de 7.0, producen cambios de elevación en la superficie del fondo oceánico. Estos cambios producen olas que se propagan a partir del epicentro pudiendo alcanzar algunas decenas de metros sobre el nivel medio del mar. Estas olas al llegar a la costa son llamadas tsunamis, término japonés que significa literalmente ola de bahía.'
                  )
                "
              >
                Tsunamis
              </div>
            </ColumnUi>
          </Row>
        </ColumnUi>
      </Row>

      <Modal
        headerColor="white"
        :showModal="showModal"
        centered
        v-on:close="close"
      >
        <template v-slot:header>
          <h2 class="modal-titulo">{{ modal.titulo }}</h2>
        </template>
        <template v-slot:body>
          <p>
            {{ modal.texto }}
          </p>
        </template>
      </Modal>
    </Container>
  </main>
</template>
<script>
import { ref, reactive } from "vue";
import Container from "@/components/ui/objects/Container";
import Row from "@/components/ui/atoms/Row.vue";
import ColumnUi from "@/components/ui/atoms/ColumnUi.vue";
import Trail from "@/components/common/Trail.vue";
import Modal from "@/components/common/Modal.vue";
import Title from "@/components/ui/atoms/Title.vue";
export default {
  name: "Glosario",
  data: function() {
    return {
      titulo: "",
      texto: "",
      active: false
    };
  },
  components: {
    Modal,
    Trail,
    Container,
    Row,
    ColumnUi,
    Title
  },
  setup() {
    let modal = reactive({});
    const openModalGlosario = (titulo, texto) => {
      showModal.value = true;
      modal.titulo = titulo;
      modal.texto = texto;
    };
    let showModal = ref(false);
    const close = () => {
      showModal.value = false;
    };

    return {
      openModalGlosario,
      close,
      showModal,
      modal
    };
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.modal-titulo {
  color: variables.$primary-color;
  text-transform: uppercase;
}
.titulo {
  color: variables.$primary-color;
  font-size: 28px;
  margin-bottom: 30px;
  margin-top: 30px;
}
.padding-lr {
  padding-left: 20px;
  padding-right: 20px;
}
.contenido {
  margin: auto;
  margin-bottom: 30px;
}
@media (max-width: 766px) {
  .contenido {
    margin-left: 3vw;
    margin-right: 3vw;
  }
}
.texto-justificado {
  text-align: justify;
}

.ter-glosario {
  background-color: variables.$primary-color;
  padding: 5px;
  padding-left: 15px;
  margin-bottom: -15px;
  border-radius: 10px;
  text-align: center;
  color: #fff;
}
.ter-glosario:hover {
  background-color: variables.$secondary-alt-color;
  color: #fff;
  padding-left: 30px;
  cursor: pointer;
  font-weight: 700;
}

.espacio {
  padding: 14px;
}
.dialogo .md-title {
  color: #0200ae;
  background: white;
}
.dialogo .md-dialog-actions {
  display: none;
}
.dialogo .md-button-content {
  text-transform: capitalize;
  color: #0200ae;
  display: none;
}
.dialogo .md-ripple {
  -webkit-mask-image: unset;
}
</style>
